// extracted by mini-css-extract-plugin
export default {"connectButtons__btnConnect":"DynamicCategoryTable_connectButtons__btnConnect__1GQWU","bg-QuickbooksDesktop":"DynamicCategoryTable_bg-QuickbooksDesktop__213nl"};